import React from 'react';
import { Leaf, Wheat } from 'lucide-react';

const MenuItem = ({ item }) => {
  const getDietaryIcon = (dietary) => {
    if (dietary.includes('vegan')) return <Leaf data-component-path="client/src/components/MenuItem.jsx" data-component-line="6:49" data-component-id="client/src/components/MenuItem.jsx:6:49" className="w-4 h-4 text-green-600" />;
    if (dietary.includes('vegetarian')) return <Leaf data-component-path="client/src/components/MenuItem.jsx" data-component-line="7:56" data-component-id="client/src/components/MenuItem.jsx:7:56" className="w-4 h-4 text-green-500" />;
    if (dietary.includes('gluten-free')) return <Wheat data-component-path="client/src/components/MenuItem.jsx" data-component-line="8:57" data-component-id="client/src/components/MenuItem.jsx:8:57" className="w-4 h-4 text-amber-600" />;
    return null;
  };

  return (
    <div data-component-path="client/src/components/MenuItem.jsx" data-component-line="13:5" data-component-id="client/src/components/MenuItem.jsx:13:5" className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
      <div data-component-path="client/src/components/MenuItem.jsx" data-component-line="14:7" data-component-id="client/src/components/MenuItem.jsx:14:7" className="relative h-56 overflow-hidden">
        <img data-component-path="client/src/components/MenuItem.jsx" data-component-line="15:9" data-component-id="client/src/components/MenuItem.jsx:15:9" 
          src={item.image} 
          alt={item.name}
          className="w-full h-full object-cover transition-transform duration-300 hover:scale-110"
          loading="lazy"
          onError={(e) => {
            e.target.src = 'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=600&q=80';
          }}
        />
        <div data-component-path="client/src/components/MenuItem.jsx" data-component-line="24:9" data-component-id="client/src/components/MenuItem.jsx:24:9" className="absolute top-3 right-3 flex gap-2">
          {item.dietary.map(diet => (
            <span data-component-path="client/src/components/MenuItem.jsx" data-component-line="26:13" data-component-id="client/src/components/MenuItem.jsx:26:13" 
              key={diet}
              className="bg-white/90 backdrop-blur-sm px-2 py-1 rounded-full text-xs font-medium text-charcoal flex items-center gap-1"
            >
              {getDietaryIcon([diet])}
              {diet}
            </span>
          ))}
        </div>
      </div>

      <div data-component-path="client/src/components/MenuItem.jsx" data-component-line="38:7" data-component-id="client/src/components/MenuItem.jsx:38:7" className="p-6">
        <div data-component-path="client/src/components/MenuItem.jsx" data-component-line="39:9" data-component-id="client/src/components/MenuItem.jsx:39:9" className="flex justify-between items-start mb-3">
          <h3 data-component-path="client/src/components/MenuItem.jsx" data-component-line="40:11" data-component-id="client/src/components/MenuItem.jsx:40:11" className="section-title text-xl text-charcoal">{item.name}</h3>
          <span data-component-path="client/src/components/MenuItem.jsx" data-component-line="41:11" data-component-id="client/src/components/MenuItem.jsx:41:11" className="text-xl font-bold text-copper">${item.price}</span>
        </div>
        <p data-component-path="client/src/components/MenuItem.jsx" data-component-line="43:9" data-component-id="client/src/components/MenuItem.jsx:43:9" className="text-gray-600 text-sm leading-relaxed">{item.description}</p>
      </div>
    </div>
  );
};

export default MenuItem;